import { render } from "./SelectDealerGroupModal.vue?vue&type=template&id=3457bb9e"
import script from "./SelectDealerGroupModal.vue?vue&type=script&lang=js"
export * from "./SelectDealerGroupModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__